export const metadata = {
  title: "UPSIGHT - 업사이트",
  description: "upsight",
};
